import { AxiosError } from "axios";
import { ErrorDetails } from "components/common/ErrorDetails";
import { BottomNav } from "components/topbar/BottomNav";
import { TopBar } from "components/topbar/TopBar";
import { useUnsavedChanges } from "contexts/UnsavedChangesContextProvider";
import { useEffect } from "react";
import { useRouteError } from "react-router";

/**
 * The router error boundary page
 */
export const RouterErrorBoundary = () => {
  const error = useRouteError() as AxiosError | Error | undefined;
  const errorString = JSON.stringify(error?.message ?? error, undefined, 2);
  const { clearUnsavedChanges } = useUnsavedChanges("router-error-boundary");
  useEffect(() => {
    clearUnsavedChanges();
  }, [clearUnsavedChanges]);

  return (
    <>
      <TopBar
        title="An error has occurred"
        showUser={false}
      />
      <ErrorDetails
        error={error}
        errorMessage={errorString}
      />
      <BottomNav />
    </>
  );
};

RouterErrorBoundary.displayName = "RouterErrorBoundary";

export default RouterErrorBoundary;
